module.exports = __webpack_public_path__ + "img/index_pic6.47e8931e.png";